import moment from 'jalali-moment'

/**
 * A Gregorian `YYYY-MM-DD` (what the API speaks) as the Jalali `YYYY/MM/DD`
 * string `CustomDatePicker` renders — its calendar is `persian` and its format
 * is `YYYY/MM/DD`, so handing it the raw API value would read 2026-09-19 as a
 * Jalali date.
 *
 * Returning `undefined` for an empty input matters: `react-multi-date-picker`
 * treats an empty string as a value it has to parse and falls back to today.
 */
export const toJalaliInputDate = (gregorian?: string) =>
    gregorian
        ? moment(gregorian, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
        : undefined
